import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import ProductModal from "./ProductModal";

import API_BASE from "../api";

function productSlug(p) {
  const name = (p.name_pl || p.name_en || "produkt")
    .trim()
    .toLowerCase()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/(^-|-$)+/g, "");

  return name + "-" + p.id;
}

export default function Shop({ lang }) {
  const location = useLocation();
  const navigate = useNavigate();
  const [products, setProducts] = useState([]);
  const [texts, setTexts] = useState(null);
  const [selectedProduct, setSelectedProduct] = useState(null);

  // Otwieraj produkt na podstawie adresu /p/nazwa-id.
  useEffect(() => {
    if (!products.length) return;

    if (location.pathname.startsWith("/p/")) {
      const slug = location.pathname.slice(3);
      const product = products.find((p) => slug.endsWith(String(p.id)));
      setSelectedProduct(product || null);
    } else {
      setSelectedProduct(null);
    }
  }, [location.pathname, products]);

  // ładowanie produktów + tekstów
  useEffect(() => {
    const load = async () => {
      try {
        const [prodRes, textRes] = await Promise.all([
          axios.get(API_BASE + "/api/products"),
          axios.get(API_BASE + "/api/texts"),
        ]);

        // upewniamy się, że każdy produkt ma tablicę images
        const migrated = (prodRes.data || []).map((p) => {
  let images = [];

  if (Array.isArray(p.images)) {
    images = [...p.images];
  } else if (p.image) {
    images = [p.image];
  }

  const videos = Array.isArray(p.videos) ? p.videos : [];

  return {
    ...p,
    images,
    videos,
  };
});

        setProducts(migrated);
        setTexts(textRes.data || {});
      } catch (err) {
        console.error("Błąd ładowania sklepu:", err);
      }
    };

    load();
  }, []);

  if (!texts) return <div className="section">Loading…</div>;

  const t = texts.shop?.[lang] || {
    title: lang === "pl" ? "Sklep" : "Shop",
    subtitle: "",
  };

  return (
    <>
      {/* MODAL PRODUKTU NA WIERZCHU */}
      {selectedProduct && (
        <ProductModal
          product={selectedProduct}
          lang={lang}
          onClose={() => navigate("/shop", { replace: true })}
        />
      )}

      <section className="section">
        <h2 className="section-title">{t.title}</h2>
        <p className="section-subtitle">{t.subtitle}</p>

        <div className="shop-grid">
          {products.map((p) => {
            const title = lang === "pl" ? p.name_pl : p.name_en;
            const firstImage =
              Array.isArray(p.images) && p.images.length > 0
                ? p.images[0]
                : null;

            return (
              <div
                key={p.id}
                className="shop-card"
                onClick={() => navigate("/p/" + productSlug(p))}
                style={{ cursor: "pointer" }}
              >
                <div className="shop-card-image">
                  {firstImage ? (
                    <img
                      src={
                        API_BASE +
                        "/images/products/thumbs/" +
                        firstImage.replace(/\.[^.]+$/, ".webp")
                      }
                      alt={title || ""}
                    />
                  ) : (
                    <div
                      style={{
                        width: "100%",
                        paddingTop: "60%",
                        background: "#eee",
                      }}
                    />
                  )}
                </div>

                <div className="shop-card-info">
                  <div className="shop-name">
                    {title || (lang === "pl" ? "(bez nazwy)" : "(no name)")}
                  </div>
                  <div className="shop-price">
                    {lang === "en" && p.priceEUR
                      ? `€${p.priceEUR} (${p.price} zł)`
                      : p.price
                      ? `${p.price} zł`
                      : ""}
                  </div>
                </div>


<div className="shop-desc">
  {(() => {
    const desc = (lang === "pl" ? p.desc_pl : p.desc_en) || "";
    const clean = desc.trim();
    const match = clean.match(/^.*?[.!?](?:\s|$)/);
    const short = match ? match[0].trim() : clean.slice(0, 140).trim();
    return short && short.length < clean.length ? `${short.replace(/[.!?…]+$/, "")}…` : short;
  })()}
</div>
              </div>
            );
          })}
        </div>
      </section>
    </>
  );
}
